import { match } from "ts-pattern";
import {
    DashboardAlertsData,
    DashboardCategories,
    type DashboardCategoriesType,
    DashboardContentSections,
} from "../models/api/admin/dashboard";
import { useDashboardAlertActions } from "../components/DashboardAlerts/useDashboardAlertActions";

export const getDashboardTabTitle = (tab: DashboardCategoriesType) => {
    /** Due to tab construction this will never hit "Risk Profiles" or "Reports" */
    return match(tab)
        .with(DashboardCategories.RiskProfiles, () => "Risk Profiles")
        .with(DashboardCategories.Drivers, () => "All Drivers")
        .with(
            DashboardCategories.ProfessionalDrivers,
            () => "Professional Drivers"
        )
        .with(DashboardCategories.Dvla, () => "DVLA Checks")
        .with(DashboardCategories.GreyFleet, () => "Grey Fleet")
        .with(
            DashboardCategories.DriverDeclarations,
            () => "Driver Declarations"
        )
        .with(DashboardCategories.Reports, () => "Reports")
        .exhaustive();
};

export const getDashboardTabFromTitle = (title: DashboardContentSections) => {
    return match(title)
        .with("All Drivers", () => DashboardCategories.Drivers)
        .with(
            "Professional Drivers",
            () => DashboardCategories.ProfessionalDrivers
        )
        .with("DVLA Checks", () => DashboardCategories.Dvla)
        .with("Grey Fleet", () => DashboardCategories.GreyFleet)
        .with(
            "Driver Declarations",
            () => DashboardCategories.DriverDeclarations
        )
        .exhaustive();
};

export const getDashboardTabData = (
    tab: DashboardCategoriesType,
    data: DashboardAlertsData | undefined
) => {
    if (!data) return undefined;
    /** Due to tab construction this will never hit "Risk Profiles" or "Reports" */
    return match(tab)
        .with(DashboardCategories.Drivers, () => data.driverAlerts)
        .with(
            DashboardCategories.ProfessionalDrivers,
            () => data.professionalDriverAlerts
        )
        .with(DashboardCategories.Dvla, () => data.licenceCheckAlerts)
        .with(DashboardCategories.GreyFleet, () => data.greyFleetAlerts)
        .with(
            DashboardCategories.DriverDeclarations,
            () => data.driverDeclarationAlerts
        )
        .otherwise(() => undefined);
};

export const getDashboardTabActions = (
    tab: DashboardCategoriesType,
    actions: ReturnType<typeof useDashboardAlertActions>
) => {
    /** Due to tab construction this will never hit "Risk Profiles" or "Reports" */
    return match(tab)
        .with(DashboardCategories.Drivers, () => actions.driverAlertAction)
        .with(
            DashboardCategories.ProfessionalDrivers,
            () => actions.professionalDriverAlertAction
        )
        .with(DashboardCategories.Dvla, () => actions.licenceCheckAlertAction)
        .with(DashboardCategories.GreyFleet, () => actions.greyFleetAlertAction)
        .with(
            DashboardCategories.DriverDeclarations,
            () => actions.driverDeclarationAlertAction
        )
        .otherwise(() => undefined);
};